import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useModals } from "src/context/ModalContext";
import { fetchBenefits } from "../../../permissions/benefits/redux/benefits.thunks";
import { postMyWorkforce } from "../actions/postWorkforce";

export const useWorkforce = () => {
  const token = sessionStorage.getItem("token");
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { closeByKey } = useModals();

  const workforceMutation = useMutation({
    mutationFn: (data) => postMyWorkforce(data, token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["workforces"] });
      queryClient.invalidateQueries({ queryKey: ["total-workforce"] });
      dispatch(fetchBenefits());
      closeByKey("Dashboard-Workforce-Create-Overview");
    },
  });

  return {
    workforceMutation,
  };
};
